import VueRouter from "vue-router";
import RouterView from "@/views/RouterView.vue";
import Index from "@/views/index/Index.vue";
//防止路由重复报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: "hash",
    // mode: "history",
    routes: [
        {
            path: "/index",
            name: "indexLayout",
            component: RouterView,
            children: [
                {
                    path: "/index",
                    name: "index",
                    component: Index,
                    meta: {
                        title: "首页",
                        keepAlive: true,
                        fatherRoute: "/index",
                        id: 1
                    }
                },
                {
                    path: "/personalCenter",
                    name: "personalCenter",
                    component: () => import("@/views/index/personalCenter.vue"),
                    meta: {
                        title: "个人中心",
                        keepAlive: true,
                        fatherRoute: "/personalCenter",
                        id: 1
                    }
                },
                {
                    path: "/mployed",
                    name: "mployed",
                    component: () => import("@/views/keyAnalysis/Mployed.vue"),
                    meta: {
                        title: "已就业人员分析",
                        keepAlive: true,
                        fatherRoute: "/keyAnalysis",
                        id: 1
                    }
                },
                {
                    path: "/unemployed",
                    name: "unemployed",
                    component: () => import("@/views/keyAnalysis/Unemployed.vue"),
                    meta: {
                        title: "未就业人员分析",
                        keepAlive: true,
                        fatherRoute: "/keyAnalysis",
                        id: 1
                    }
                },
                {
                    path: "/keyAnalysis",
                    name: "keyAnalysis",
                    component: () => import("@/views/keyAnalysis/KeyAnalysis.vue"),
                    meta: {
                        title: "高校毕业生分析",
                        keepAlive: true,
                        fatherRoute: "/keyAnalysis",
                        id: 1
                    }
                },
                {
                    path: "/migrantWorkers",
                    name: "migrantWorkers",
                    component: () => import("@/views/keyAnalysis/MigrantWorkers.vue"),
                    meta: {
                        title: "外出务工人员分析",
                        keepAlive: true,
                        fatherRoute: "/keyAnalysis",
                        id: 1
                    }
                },
                {
                    path: "/universalParameter",
                    name: "universalParameter",
                    component: () => import("@/views/universalParameter/Main.vue"),
                    redirect: "/universalParameter/universalParameter",
                    children: [
                        {
                            path: "/universalParameter/universalParameter",
                            name: "universalParameter",
                            component: () => import("@/views/universalParameter/universalParameter.vue"),
                            meta: {
                                title: "万能台账",
                                keepAlive: true,
                                fatherRoute: "/universalParameter",
                                fatherRoute2: "/universalParameter/universalParameter",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "万能台账",
                        keepAlive: true,
                        fatherRoute: "/universalParameter",
                        id: 1
                    }
                },
                {
                    path: "/parameterDeatils",
                    name: "parameterDeatils",
                    component: () => import("@/views/universalParameter/Main.vue"),
                    redirect: "/universalParameter/parameterDeatils",
                    children: [

                        {
                            path: "/universalParameter/parameterDeatils",
                            name: "parameterDeatils",
                            component: () => import("@/views/universalParameter/parameterDeatils.vue"),
                            meta: {
                                title: "查看个人画像",
                                keepAlive: true,
                                fatherRoute: "/universalParameter",
                                fatherRoute2: "/universalParameter/parameterDeatils",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "万能台账",
                        keepAlive: true,
                        fatherRoute: "/universalParameter",
                        id: 1
                    }
                },
                {
                    path: "/addParameter",
                    name: "addParameter",
                    component: () => import("@/views/universalParameter/Main.vue"),
                    redirect: "/universalParameter/addParameter",
                    children: [
                        {
                            path: "/universalParameter/addParameter",
                            name: "addParameter",
                            component: () => import("@/views/universalParameter/addParameter.vue"),
                            meta: {
                                title: "新增编辑个人画像",
                                keepAlive: true,
                                fatherRoute: "/universalParameter",
                                fatherRoute2: "/universalParameter/addParameter",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "万能台账",
                        keepAlive: true,
                        fatherRoute: "/universalParameter",
                        id: 1
                    }
                },
                {
                    path: "/portrait",
                    name: "portrait",
                    component: () => import("@/views/portrait/Main.vue"),
                    redirect: "/portrait/portrait",
                    children: [
                        {
                            path: "/portrait/portrait",
                            name: "portrait",
                            component: () => import("@/views/portrait/portrait.vue"),
                            meta: {
                                title: "劳动力全景画像",
                                keepAlive: true,
                                fatherRoute: "/portrait",
                                fatherRoute2: "/portrait/portrait",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "劳动力查询",
                        keepAlive: true,
                        fatherRoute: "/portrait",
                        id: 1
                    }
                },
                {
                    path: "/laborForce",
                    name: "laborForce",
                    component: () => import("@/views/portrait/Main.vue"),
                    redirect: "/portrait/laborForce",
                    children: [
                        {
                            path: "/portrait/laborForce",
                            name: "laborForce",
                            component: () => import("@/views/portrait/laborForce.vue"),
                            meta: {
                                title: "劳动力全景画像",
                                keepAlive: true,
                                fatherRoute: "/portrait",
                                fatherRoute2: "/portrait/laborForce",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "劳动力查询",
                        keepAlive: true,
                        fatherRoute: "/portrait",
                        id: 1
                    }
                },
                {
                    path: "/othlaborForce",
                    name: "othlaborForce",
                    component: () => import("@/views/portrait/Main.vue"),
                    redirect: "/portrait/othlaborForce",
                    children: [
                        {
                            path: "/portrait/othlaborForce",
                            name: "othlaborForce",
                            component: () => import("@/views/portrait/othlaborForce.vue"),
                            meta: {
                                title: "劳动力全景画像",
                                keepAlive: true,
                                fatherRoute: "/portrait",
                                fatherRoute2: "/portrait/othlaborForce",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "劳动力查询",
                        keepAlive: true,
                        fatherRoute: "/portrait",
                        id: 1
                    }
                },
                {
                    path: "/system",
                    name: "system",
                    component: () => import("@/views/system/Main.vue"),
                    redirect: "/system/system",
                    children: [
                        {
                            path: "/system/system",
                            name: "system",
                            component: () => import("@/views/system/system.vue"),
                            meta: {
                                title: "登录日志",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/system",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "系统管理",
                        keepAlive: true,
                        fatherRoute: "/system",
                        id: 1
                    }
                },
                {
                    path: "/InformationService",
                    name: "InformationService",
                    component: () => import("@/views/InformationService/Main.vue"),
                    redirect: "/InformationService/InformationService",
                    children: [
                        {
                            path: "/InformationService/InformationService",
                            name: "InformationService",
                            component: () => import("@/views/InformationService/InformationService.vue"),
                            meta: {
                                title: "采集更新进度",
                                keepAlive: true,
                                fatherRoute: "/InformationService",
                                fatherRoute2: "/InformationService/InformationService",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "采集分析",
                        keepAlive: true,
                        fatherRoute: "/InformationService",
                        id: 1
                    }
                },
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/login/Login.vue"),
            meta: {
                title: "登录"
            }
        },
        {
            path: "/forgotPassword",
            name: "forgotPassword",
            component: () => import("@/views/login/ForgotPassword.vue"),
            meta: {
                title: "忘记密码"
            }
        },
        //登录
        {
            path: "/indexpdf",
            name: "indexpdf",
            component: () => import('@/views/Index.vue')
        },
    ]
})

router.onError((error) => {
    const isChunkLoadFailed = /Loading chunk .* failed/i.test(error.message)
        || error.name === 'ChunkLoadError'
    if (isChunkLoadFailed) {
        const reloadKey = 'chunk_reload_ts'
        const lastReload = Number(sessionStorage.getItem(reloadKey) || 0)
        if (!lastReload || Date.now() - lastReload > 10000) {
            sessionStorage.setItem(reloadKey, String(Date.now()))
            window.location.reload()
        }
    }
})

router.beforeEach(async (to, from, next) => {
    let token = localStorage.getItem('token');
    if (to.name == "login") {
        next()
    } else {
        if (!token) {
            next({ name: 'login' })
        } else {
            if (to.name) {
                next()
            } else {
                next({ name: 'index' })
            }
        }
    }
})
export default router
